import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

class SearchBar extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { defaultSearchValue: '' }
  }

  handleChange(e) {
    this.setState({ defaultSearchValue: e.target.value })
  }

  handleSearchSubmit(e) {
    e.preventDefault()
    this.props.updateFilter({ search: this.state.defaultSearchValue })
  }

  componentDidMount() {
    const { searchTerm } = this.props
    if (searchTerm) {
      this.setState({ defaultSearchValue: searchTerm })
    }
  }

  handleSearchReset(e) {
    this.setState({ defaultSearchValue: '' })
    this.props.updateFilter({ search: '' })
  }

  handleEnterKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleSearchSubmit(e)
    }
  }

  render() {
    const { searchError } = this.props
    let searchFormGroupClass = 'input-group'
    if (searchError) {
      searchFormGroupClass = 'input-group has-error'
    }

    return (
      <div style={{ minHeight: '48px' }}>
        <div className={searchFormGroupClass}>
          <input
            onKeyPress={(e) => this.handleEnterKeyPress(e)}
            name='search-field'
            // TODO: obsolete code
            // eslint-disable-next-line react/no-string-refs
            ref='userSearchInput'
            className='form-control'
            placeholder='Search'
            value={this.state.defaultSearchValue}
            onChange={(e) => this.handleChange(e)}
          />
          <button
            name='search-btn'
            className='btn btn-default'
            type='button'
            onClick={(e) => this.handleSearchSubmit(e)}
          >
            Search
          </button>
          <button name='reset-btn' className='btn btn-default' type='button' onClick={(e) => this.handleSearchReset(e)}>
            Reset
          </button>
        </div>
        <label className='error border-size-sm' htmlFor='search-field'>
          {searchError}
        </label>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBar))
